'use client';

import NextLink from 'next/link';
import type { ComponentProps } from 'react';
import { requestNavigationScrollReset } from './NavigationScrollReset';

type SiteLinkProps = ComponentProps<typeof NextLink>;

function normalizeInternalHref(href: SiteLinkProps['href']) {
    if (typeof href !== 'string' || !href.startsWith('/') || href.startsWith('//')) return href;

    const [pathAndQuery, hash = ''] = href.split('#', 2);
    const [pathname, query = ''] = pathAndQuery.split('?', 2);
    const lastSegment = pathname.split('/').at(-1) ?? '';
    const normalizedPath =
        pathname === '/' || pathname.endsWith('/') || lastSegment.includes('.')
            ? pathname
            : `${pathname}/`;

    return `${normalizedPath}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`;
}

export default function SiteLink(props: SiteLinkProps) {
    const { onNavigate, ...linkProps } = props;

    return (
        <NextLink
            {...linkProps}
            href={normalizeInternalHref(props.href)}
            prefetch={false}
            onNavigate={(event) => {
                let navigationPrevented = false;

                onNavigate?.({
                    preventDefault: () => {
                        navigationPrevented = true;
                        event.preventDefault();
                    },
                });

                if (navigationPrevented) return;
                requestNavigationScrollReset();
            }}
        />
    );
}
